import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ru from './ru.json'
import en from './en.json'

const defaultLanguage = (import.meta.env.VITE_DEFAULT_LANGUAGE ?? 'ru') as 'ru' | 'en'

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
    },
    lng: defaultLanguage,
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
  })

export default i18n
